export default __webpack_public_path__ + "static/media/captain.21579fb2.svg";